import { render, staticRenderFns } from "./TransferPricingIndex.vue?vue&type=template&id=6069d636"
import script from "./TransferPricingIndex.vue?vue&type=script&lang=js"
export * from "./TransferPricingIndex.vue?vue&type=script&lang=js"
import style0 from "./TransferPricingIndex.vue?vue&type=style&index=0&id=6069d636&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports